import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["alertButton", "alertText", "scrollTop"]

    connect() {
        this.scrollThreshold = window.innerHeight / 3
        this.checkScroll()

        // Add resize listener to handle window resize
        this.boundCheckScroll = this.checkScroll.bind(this)
        window.addEventListener('resize', this.boundCheckScroll)
    }

    disconnect() {
        window.removeEventListener('resize', this.boundCheckScroll)
    }

    checkScroll() {
        const scrollPosition = window.scrollY
        const isWideScreen = window.innerWidth > 1024

        // Hide/show alert button text
        // Always hide text on screens wider than 1024px
        if (isWideScreen || scrollPosition > this.scrollThreshold) {
            this.alertTextTarget.classList.add('hidden')
            this.alertButtonTarget.classList.remove('w-[157px]')
            this.alertButtonTarget.classList.add('w-[46px]')
        } else {
            this.alertTextTarget.classList.remove('hidden')
            this.alertButtonTarget.classList.add('w-[157px]')
            this.alertButtonTarget.classList.remove('w-[46px]')
        }

        // Show/hide scroll to top button
        if (scrollPosition > this.scrollThreshold) {
            this.scrollTopTarget.classList.remove('hidden')
        } else {
            this.scrollTopTarget.classList.add('hidden')
        }
    }

    scrollToTop(event) {
        event.preventDefault()
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }
}